
import { mapMutations } from 'vuex';
import WpImage from '~/components/ui/img.vue';

export default {
  name: 'CtaSmall',

  components: {
    WpImage,
  },

  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },

  methods: {
    ...mapMutations(['toggleContactForm']),
  },
};
